(() => {
  if (customElements.get('fc3-carousel')) return;

  customElements.define('fc3-carousel', class extends HTMLElement {
    connectedCallback() {
      this.listeners?.abort();
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      const rail = this.querySelector('.fc3__rail');
      if (!rail) return;

      const previous = this.querySelector('.fc3__arrow--previous');
      const next = this.querySelector('.fc3__arrow--next');
      let pointer = null;
      let suppressClick = false;

      const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
      const step = () => {
        const firstPage = rail.querySelector('.fc3__page');
        const firstCard = rail.querySelector('.fc3__card');
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        return innerWidth < 700
          ? (firstPage?.getBoundingClientRect().width || rail.clientWidth)
          : ((firstCard?.getBoundingClientRect().width || rail.clientWidth) + gap) * 4;
      };
      const update = () => {
        const maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
        const position = Math.min(maximum, Math.max(0, rail.scrollLeft));
        const visible = Math.min(1, rail.clientWidth / rail.scrollWidth);
        const travel = maximum ? position / maximum : 0;
        this.style.setProperty('--fc3-progress', String(visible + (1 - visible) * travel));
        if (previous) previous.disabled = position <= 1;
        if (next) next.disabled = position >= maximum - 1;
      };
      const scroll = direction => rail.scrollBy({
        left: direction * step(),
        behavior: reducedMotion() ? 'auto' : 'smooth'
      });
      const finish = () => {
        if (pointer && rail.hasPointerCapture(pointer.id)) rail.releasePointerCapture(pointer.id);
        pointer = null;
        rail.classList.remove('is-dragging');
      };

      previous?.addEventListener('click', () => scroll(-1), options);
      next?.addEventListener('click', () => scroll(1), options);
      rail.addEventListener('scroll', update, { ...options, passive: true });
      window.addEventListener('resize', update, options);
      rail.addEventListener('keydown', event => {
        suppressClick = false;
        if (!['ArrowRight', 'ArrowLeft'].includes(event.key)) return;
        event.preventDefault();
        scroll(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      rail.addEventListener('dragstart', event => event.preventDefault(), options);
      rail.addEventListener('pointerdown', event => {
        suppressClick = false;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, left: rail.scrollLeft, dragging: false };
      }, options);
      rail.addEventListener('pointermove', event => {
        if (!pointer || pointer.id !== event.pointerId) return;
        if (!(event.buttons & 1)) {
          finish();
          return;
        }
        const dx = event.clientX - pointer.x;
        const dy = event.clientY - pointer.y;
        if (!pointer.dragging && Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) {
          pointer.dragging = true;
          suppressClick = true;
          rail.classList.add('is-dragging');
          rail.setPointerCapture(event.pointerId);
        }
        if (pointer.dragging) {
          event.preventDefault();
          rail.scrollLeft = pointer.left - dx;
        }
      }, options);
      rail.addEventListener('pointerup', finish, options);
      rail.addEventListener('pointercancel', finish, options);
      rail.addEventListener('lostpointercapture', finish, options);
      rail.addEventListener('click', event => {
        if (!suppressClick || event.detail === 0) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        suppressClick = false;
      }, { ...options, capture: true });

      update();
    }

    disconnectedCallback() {
      this.listeners?.abort();
      this.querySelector('.fc3__rail')?.classList.remove('is-dragging');
    }
  });
})();